import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminClientDetailsRaw = React.lazy(() => import(/* webpackChunkName: "AdminClientDetails" */ './ClientDetails'));
export const AdminClientDetails = () => (React.createElement(Page, { title: "Client", description: "Client" },
    React.createElement(Main, { sidebar: true },
        React.createElement("div", { className: "container-fluid att-main no-pad-r" },
            React.createElement("div", { className: "no-pad attorney-wrap " },
                React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
                    React.createElement(AdminClientDetailsRaw, null)))))));
